/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {getFormDropdownOptions} from '../../helpers/formDropdownOptions';

export const BLOCK_NAME = 'snap_action_reset_page_V3';

function defineBlock(forms) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField('reset form ')
                .appendField(new Blockly.FieldDropdown(forms), 'FORMSLUG');
            this.appendStatementInput('THEN').appendField('then');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reset a form or a screen in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#app-actions');
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const formSlug = block.getFieldValue('FORMSLUG');
            const formFields = formSlug.split('<<<>>>');
            const formDataGenyId = formFields[0];
            const pageId = formFields[1];

            const innerBlockCode = Blockly.JavaScript.statementToCode(block, 'THEN');
            const code = `
                actionsModule.executeActionWithCallback({
                    action: {
                        actionType: 'resetForm'
                        },
                        formDataGenyId: '${formDataGenyId || pageId}',
                    }, function() {
                        ${innerBlockCode}
                });\n`;

            return code;
        }
    }
}

const ResetPage = function (props) {
    ResetPage.blockName = BLOCK_NAME;

    const forms = getFormDropdownOptions(props.context);
    if (!forms.length) {
        return null;
    }

    Blockly.Blocks[BLOCK_NAME] = defineBlock(forms);
    const generators = defineGenerators();
    for (const i in generators) {
        Blockly[i][BLOCK_NAME] = generators[i];
    }

    return (
        <block type={BLOCK_NAME}></block>
    );
};

ResetPage.propTypes = {
    context: PropTypes.object.isRequired
};

export default ResetPage;
